import React from 'react'
import { BoxProps } from '@chakra-ui/core'

import { Box } from '../Box'

export interface HeadingProps extends BoxProps {}

const sizes: Record<string, BoxProps['fontSize']> = {
  '2xl': ['4xl', null, '5xl'],
  xl: ['3xl', null, '4xl'],
  lg: ['2xl', null, '3xl'],
  md: ['xl', null, '2xl'],
  sm: ['lg', null, 'xl'],
  xs: 'md',
  '2xs': 'sm',
}

export const Heading = ({ fontSize = 'md', ...restProps }: HeadingProps) => {
  return (
    <Box
      as="h2"
      fontFamily="heading"
      fontSize={sizes[fontSize as string] || fontSize}
      fontWeight="bold"
      lineHeight="shorter"
      {...restProps}
    />
  )
}

export default Heading
